import React, { Component } from 'react';
import {
  Row, Col, Form, Radio, Select, Input, DatePicker, InputNumber,
} from 'antd';
import { formPropType } from 'utils/propType';
import {
  FormControl, FileUpload, FormUtils, FormRules,
} from 'form-control';
import PropTypes from 'prop-types';
import autobind from 'react-autobind';
import translate from 'app/translations';
import { PROFILE_STEP_TYPES } from 'app/constants';
import moment from 'moment';
import { getApiUrl } from 'app/apiClient';
import AgentProfilePropType from '../AgentProfilePropType';
import WizardNav from './WizardNav';
import DocumentTable from './DocumentTable';

const RadioGroup = Radio.Group;
const { Option } = Select;
const { TextArea } = Input;
const DOCUMENT_TYPE = 'E_AND_O';


export class EandOComponent extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
    this.fileUploadRef = undefined;
    this.state = { isSubmitted: false };
  }

  onSubmit(nextPage) {
    const { form } = this.props;
    form.validateFieldsAndScroll((errors, values) => {
      const payload = {
        ...values,
        fileByWhom: values.fileByWhom ? values.fileByWhom : '',
        outcomeDescription: values.outcomeDescription ? values.outcomeDescription : '',
      };


      const uploadErrors = this.fileUploadRef && this.fileUploadRef.validateFiles();
      this.setState({
        isSubmitted: true,
      });

      if (!errors && !uploadErrors) {
        if (this.fileUploadRef) {
          this.fileUploadRef.handleUpload()
            .then((documentResponse) => {
              const { documents } = documentResponse.data;
              if (documents.length > 0) {
                this.props.onSetEandODocsRequest(documents);
              }

              this.saveEandOInfo(nextPage, payload);
            });
        } else {
          this.saveEandOInfo(nextPage, payload);
        }
      }
    });
  }

  onClaimFiledChange(changeEvt) {
    if (changeEvt.target.value !== 'Yes') {
      this.props.form.resetFields([
        'fileByWhom',
        'outcomeDescription',
      ]);
    }
  }

  saveEandOInfo(nextPage, fieldValues) {
    const payload = {
      ...fieldValues,
      expiryDate: moment.utc(fieldValues.expiryDate),
      claimFiled: FormUtils.yesNoToBoolean(fieldValues.claimFiled),
      perClaimLimit: Number(fieldValues.perClaimLimit || 0),
      aggregateLimit: Number(fieldValues.aggregateLimit || 0),
    };
    this.props.onSaveEandOInfoRequest(nextPage, payload);
    this.setState({
      isSubmitted: false,
    });
  }

  showClaimDetails() {
    let hasClaimFiled = this.props.form.getFieldValue('claimFiled');
    if (typeof hasClaimFiled === 'undefined') {
      const { eo } = this.props.agentProfile;
      const claimState = eo.claimFiled;
      hasClaimFiled = FormUtils.booleanToYesNo(claimState);
    }
    return hasClaimFiled;
  }

  render() {
    const { agentProfile } = this.props;
    const {
      eo, constants, accessToken, applicationId, isCallInprogress,
    } = agentProfile;

    const {
      INSURANCE,
      DOCUMENT,
    } = constants;

    const yesNoRadio = [
      { label: this.t('Generic.yes'), value: 'Yes' },
      { label: this.t('Generic.no'), value: 'No' },
    ];

    const { form } = this.props;

    const hasDocs = (eo.documentList && eo.documentList.length > 0);

    return (
      <div className="eando">
        <Form layout="vertical">
          <div className="card-container responsive-border">
            <h2 className="orange-text">{this.t('EandO.insurance')}</h2>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="insuranceType"
                  displayName={this.t('EandO.insuranceType')}
                  initialValue={eo.insuranceType || undefined}
                  id="individual"
                  rules={[FormRules.REQUIRED]}
                >
                  <Select
                    showSearch
                    autoComplete="off"
                    filterOption={(userInput, option) => FormUtils.filterOptions(userInput, option)}
                    placeholder={this.t('EandO.select')}
                  >
                    {
                      INSURANCE.map(kv => (<Option value={kv.value} key={kv.value}>{kv.name}</Option>))
                    }
                  </Select>
                </FormControl>
              </Col>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="policyNumber"
                  displayName={this.t('EandO.policyNumber')}
                  initialValue={eo.policyNumber}
                  rules={[FormRules.REQUIRED]}
                >
                  <Input
                    placeholder={this.t('EandO.policyNumber')}
                    autoComplete="off"
                  />
                </FormControl>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="nameOfInsured"
                  displayName={this.t('EandO.nameOfInsured')}
                  initialValue={eo.nameOfInsured}
                  rules={[FormRules.REQUIRED]}
                >
                  <Input
                    placeholder={this.t('EandO.nameOfInsured')}
                    autoComplete="off"
                  />
                </FormControl>
              </Col>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="carrierName"
                  displayName={this.t('EandO.carrierName')}
                  initialValue={eo.carrierName}
                  rules={[FormRules.REQUIRED]}
                >
                  <Input
                    placeholder={this.t('EandO.carrierName')}
                    autoComplete="off"
                  />
                </FormControl>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} md={24}>
                <FormControl
                  form={form}
                  fieldName="nameOfPersonCovered"
                  displayName={this.t('EandO.nameOfPersonCovered')}
                  initialValue={eo.nameOfPersonCovered}
                  rules={[FormRules.REQUIRED]}
                >
                  <Input
                    placeholder={this.t('EandO.nameOfPersonCovered')}
                    autoComplete="off"
                  />
                </FormControl>
              </Col>

            </Row>

            <Row gutter={16}>
              <Col xs={24} sm={8}>
                <Form.Item
                  label={this.t('EandO.expiryDate')}
                >
                  {form.getFieldDecorator('expiryDate', {
                    rules: [{ type: 'object', required: true, message: this.t('EandO.datePickerRule') }],
                    initialValue: eo.expiryDate ? moment(eo.expiryDate, 'YYYY-MM-DD') : undefined,
                  })(
                    <DatePicker
                      format="YYYY-MM-DD"
                      disabledDate={FormUtils.pastDates}
                      style={{ width: '100%' }}
                    />,
                  )}
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <FormControl
                  form={form}
                  fieldName="perClaimLimit"
                  displayName={this.t('EandO.perClaimLimit')}
                  initialValue={eo.perClaimLimit || undefined}
                  rules={[FormRules.POSITIVEINT, FormRules.REQUIRED, { [FormRules.MAXNUMERIC]: [9999999, '$', ''] }]}
                >
                  <InputNumber
                    type="number"
                    autoComplete="off"
                    className="currency-input closest-dollar"
                    min={1}
                    step={1}
                    precision={0}
                  />
                </FormControl>

              </Col>
              <Col xs={24} sm={8}>
                <FormControl
                  form={form}
                  fieldName="aggregateLimit"
                  displayName={this.t('EandO.aggregateLimit')}
                  initialValue={eo.aggregateLimit || undefined}
                  rules={[FormRules.REQUIRED, FormRules.POSITIVEINT, { [FormRules.MAXNUMERIC]: [9999999, '$', ''] }]}
                >
                  <InputNumber
                    type="number"
                    autoComplete="off"
                    className="currency-input closest-dollar"
                    min={0}
                    step={1}
                    precision={0}
                  />
                </FormControl>

              </Col>
            </Row>

            <Row gutter={16} className="m-b-16">
              <Col xs={24} md={24}>
                <FormControl
                  form={form}
                  fieldName="claimFiled"
                  displayName={this.t('EandO.claimFiled')}
                  initialValue={FormUtils.booleanToYesNo(eo.claimFiled) || undefined}
                >
                  <RadioGroup onChange={this.onClaimFiledChange} options={yesNoRadio} />
                </FormControl>

                {this.showClaimDetails() === 'Yes' && (
                  <div>
                    <FormControl
                      form={form}
                      fieldName="fileByWhom"
                      displayName={this.t('EandO.fileByWhom')}
                      initialValue={eo.fileByWhom}
                    >
                      <Input
                        placeholder={this.t('EandO.fileByWhom')}
                        autoComplete="off"
                      />
                    </FormControl>

                    <FormControl
                      form={form}
                      fieldName="outcomeDescription"
                      displayName={this.t('EandO.outcomeDescription')}
                      initialValue={eo.outcomeDescription}
                    >
                      <TextArea
                        autosize
                        autoComplete="off"
                        placeholder={this.t('EandO.outcomeDescription')}
                      />
                    </FormControl>
                  </div>
                )}

                {!hasDocs && (
                  <FileUpload
                    ref={(c) => { this.fileUploadRef = c; }}
                    isSubmitted={this.state.isSubmitted}
                    displayName={this.t('EandO.uploadSupportingDocumentation')}
                    errorMsg={this.t('FormControl.validate.required', { fieldName: this.t('EandO.uploadSupportingDocumentation') })}
                    required
                    docType={DOCUMENT_TYPE}
                    metaData={{ type: DOCUMENT_TYPE }}
                    endpoint={`${getApiUrl()}/applications/${applicationId}/uploads?accessToken=${accessToken}`}
                    multiple={false}
                    accept=".pdf"
                  />
                )}
              </Col>
            </Row>
          </div>

          {hasDocs && (
            <div className="m-b-16">
              <DocumentTable
                agentProfile={agentProfile}
                documentList={eo.documentList || []}
                documentTypes={DOCUMENT}
                onDeleteDocument={this.props.onDeleteEandODocumentRequest}
              />
            </div>
          )}
          <p className="medium-text">
            {this.t('EandO.confirm')}
          </p>
          <WizardNav
            agentProfile={this.props.agentProfile}
            isCallInProgress={isCallInprogress}
            currentPage={PROFILE_STEP_TYPES.E_AND_O}
            onNavigate={this.onSubmit}
            showDivider={!hasDocs}
          />
        </Form>
      </div>
    );
  }
}

EandOComponent.propTypes = {
  form: PropTypes.shape(formPropType).isRequired,
  agentProfile: PropTypes.shape(AgentProfilePropType).isRequired,
  onSaveEandOInfoRequest: PropTypes.func.isRequired,
  onDeleteEandODocumentRequest: PropTypes.func.isRequired,
  onSetEandODocsRequest: PropTypes.func.isRequired,
};

export default Form.create()(EandOComponent);
